"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewFreeModuleModalSchema = void 0;
const baseSchema_1 = require("../baseSchema");
const baseViewSchema_1 = require("../baseSchema/baseViewSchema");
class ViewFreeModuleModalSchema extends baseViewSchema_1.BaseViewSchema {
    constructor({ step }) {
        super({ arrivedFrom: baseSchema_1.ArrivedFrom.MODULE_EDITOR });
        this.step = step;
        this.action = baseSchema_1.ActionsName.VIEW_FREE_MODULE_MODAL;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            step: this.step,
            action: this.action
        };
    }
}
exports.ViewFreeModuleModalSchema = ViewFreeModuleModalSchema;
